// extracted by mini-css-extract-plugin
module.exports = {"default":"DesktopBrowserConfiguratorResolution__default__3S7tu","label":"DesktopBrowserConfiguratorResolution__label__2tBIb"};